import React from 'react';
import styled from 'styled-components/macro';
import Placeholder from '@tovia/man-ui/lib/components/Placeholder/Placeholder';

type Props = {
  direction: 'left' | 'right';
};

export const GalleryNavigationPlaceholder = (props: Props) => {
  const { direction = 'left' } = props;
  const { Line } = Placeholder;

  return (
    <PaginationWrap direction={direction}>
      <Line medium thick />
    </PaginationWrap>
  );
};

const PaginationWrap = styled(Placeholder)<{ direction: 'left' | 'right' }>`
  display: flex;
  justify-content: ${(props) => (props.direction === 'left' ? 'flex-start' : 'flex-end')};
  margin: 15px 0 !important;

  .line {
    width: 235px;
    height: 115px;
  }
`;
